import {combineReducers} from 'redux';

import {PreferenceTypes, UserTypes} from 'mattermost-redux/action_types';
import type {GenericAction} from 'mattermost-redux/types/actions';
import type {PreferenceType} from 'mattermost-redux/types/preferences';

function getKey(preference: PreferenceType) {
    return `${preference.category}--${preference.name}`;
}

const newEditorEnabledPreferences: PreferenceType = {
    user_id: '',
    category: 'advanced_settings',
    name: 'feature_enabled_new_editor',
    value: 'true',
};

function setAllPreferences(preferences: PreferenceType[]): Record<string, PreferenceType> {
    const nextState: Record<string, PreferenceType> = {
        [getKey(newEditorEnabledPreferences)]: newEditorEnabledPreferences,
    };

    if (preferences) {
        for (const preference of preferences) {
            nextState[getKey(preference)] = preference;
        }
    }

    return nextState;
}

function myPreferences(state: Record<string, PreferenceType> = {}, action: GenericAction) {
    switch (action.type) {
    case PreferenceTypes.RECEIVED_ALL_PREFERENCES:
        return setAllPreferences(action.data);

    case UserTypes.LOGIN: // Used by the mobile app
        return setAllPreferences(action.data.preferences);

    case PreferenceTypes.RECEIVED_PREFERENCES: {
        const nextState = {...state};

        if (action.data) {
            for (const preference of action.data) {
                nextState[getKey(preference)] = preference;
            }
        }

        return nextState;
    }
    case PreferenceTypes.DELETED_PREFERENCES: {
        const nextState = {...state};

        if (action.data) {
            for (const preference of action.data) {
                Reflect.deleteProperty(nextState, getKey(preference));
            }
        }

        return nextState;
    }

    case UserTypes.LOGOUT_SUCCESS:
        return {};
    default:
        return state;
    }
}

export default combineReducers({

    // object where the key is the category-name and has the corresponding value
    myPreferences,
});
